import React from "react";
import { useAuth } from "@/lib/auth";
import CarePlansPanel from "@/components/CarePlansPanel";
import { useTelemetry } from "@/lib/telemetry";

/**
 * Care Planning page — Phase 2.
 * Per-specialty care plan templates (patient goals + provider tasks).
 * Nephrology view continues to link to the pre-existing AdvancedCarePlanning
 * flow via a call-out; other specialties use the new templates directly.
 */
export default function CarePlanning() {
  const { user } = useAuth();
  const defaultSpecialty = user?.specialty || "nephrology";
  useTelemetry("care-planning", "open", defaultSpecialty);
  return (
    <div data-testid="care-planning-page">
      <CarePlansPanel defaultSpecialty={defaultSpecialty} />
    </div>
  );
}
